import { Box, Text } from '@chakra-ui/react'

export const DashboardLoading = () => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
        >
            <Text fontSize="lg" color="gray.500">
                Carregando...
            </Text>
        </Box>
    )
}
